import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { CardActionType } from '../enums/cardActionType'

export const getCardActionItems = (
  activeCardMenuActions: CardActionType[],
  t: TFunction,
): NavItem<CardActionType>[] => {
  const allMenuItems: NavItem<CardActionType>[] = [
    {
      children: t('bank.accounts.list.card.actions.connect'),
      id: CardActionType.ConnectToBank,
      value: CardActionType.ConnectToBank,
    },
    {
      children: t('bank.accounts.list.card.actions.upload'),
      id: CardActionType.UploadToAccount,
      value: CardActionType.UploadToAccount,
    },
    {
      children: t('bank.accounts.list.card.actions.download_transactions'),
      id: CardActionType.DownloadTransactions,
      value: CardActionType.DownloadTransactions,
    },
    {
      children: t('bank.accounts.list.card.actions.edit'),
      id: CardActionType.EditAccount,
      value: CardActionType.EditAccount,
    },
    {
      children: t('bank.accounts.list.card.actions.edit'),
      id: CardActionType.EditAccountName,
      value: CardActionType.EditAccountName,
    },
    {
      children: t('bank.accounts.list.card.actions.hide'),
      id: CardActionType.HideAccount,
      value: CardActionType.HideAccount,
    },
    {
      children: t('bank.accounts.list.card.actions.remove_connection'),
      id: CardActionType.RemoveConnection,
      value: CardActionType.RemoveConnection,
    },
  ]

  const activeMenuItems = allMenuItems.filter(
    (item) => activeCardMenuActions.includes(item.id as CardActionType) && item.id !== CardActionType.ConnectToBank,
  )

  return activeMenuItems
}
